import useScrollPosition from 'hooks/useScrollPosition';
import {
  desktopBlueNavbarThreshold,
  mobileBlueNavbarThreshold,
} from 'hooks/useWhiteHeader';
import { useViewContext } from 'providers/ViewContextProvider';
import { useState } from 'react';

export const useScrollCategoryList = () => {
  const [isScrollDown, setIsScrollDown] = useState(true);
  const [beyondThreshold, setBeyondThreshold] = useState(false);
  const { isMobileView } = useViewContext();

  useScrollPosition(({ prevPos, currPos }) => {
    setIsScrollDown(currPos.y - prevPos.y < 0 && currPos.y < 0);
    setBeyondThreshold(
      currPos.y < 0 &&
        Math.abs(currPos.y) >
          (isMobileView
            ? mobileBlueNavbarThreshold
            : desktopBlueNavbarThreshold)
    );
  }, []);

  return {
    isScrollDown,
    beyondThreshold,
  };
};
